import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import NavbarIconsContinents from "../generic-nav-bar/NavbarIconsContinents";
import SearchBackContinent from "../generic-search/SearchBackContinent";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import TableContinents from "./TableContinents";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { cleanSearchingContinentsPaginated, continentCleanSearchText, continentStartDelete, selectContinents, startLoadingContinentsPaginated, startSearchingContinentsPaginated } from "../../app/actions/catalogContinentActions";

const ID_FORM = "admin-continent";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListContinents = () => {
  debugLogPages(':: ListContinents');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogContinentsS, catalogContinentsP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalogContinent);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    dispatch(cleanSearchingContinentsPaginated());
    dispatch(continentCleanSearchText());
    dispatch(startLoadingContinentsPaginated(pageInitial, itemsPerPage));
    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditContinents", method: "onEditRow", event: "EditContinents-Clicked" });

    dispatch(selectContinents(row));
    if (catalogContinentsS && catalogContinentsS.length > 0) {
      navigate("/admin-continent/edit-continent", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-continent/edit-continent");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteContinents", method: "onDeleteRow", event: "DeleteContinents-Clicked" });
    dispatch(continentStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {
    
    if (catalogContinentsS && catalogContinentsS.length > 0) {
      dispatch(startSearchingContinentsPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingContinentsPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogContinentsS && catalogContinentsS.length > 0) {
      dispatch(startSearchingContinentsPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingContinentsPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsContinents page={"listContinents"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackContinent searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {catalogContinentsS && catalogContinentsS.length > 0 ? (
        <TableContinents data={catalogContinentsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableContinents data={catalogContinentsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogContinentsS && catalogContinentsS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListContinents;
